export default __webpack_public_path__ + "static/media/How solution works (1).4c01dfe6.png";